module.exports = __webpack_public_path__ + "static/media/GraviolaSoft-Medium.6f4972fd.otf";